export default {
  empty_list: "Aucune catégorie pour l'instant",
  uses_restaurant_open_times: "Utilise les horaires d'ouverture du restaurant",
  products_creation_disabled:
    "En raison de l'intégration active avec {{integration}}, la création de nouveaux produits n'est pas autorisée. Pour modifier le menu, effectuez les changements dans {{integration}} et synchronisez le menu.",
  buttons: {
    add_category: 'Ajouter une catégorie',
  },
  toasts: {
    something_went_wrong: "Une erreur s'est produite",
  },
};
